import React from 'react'
import { inject, observer } from 'mobx-react'
import Summary from './Summary'
import classnames from 'classnames'
import DemographicsBarChart from './demographicsBarChart/DemographicsBarChart'
import Icon from 'components/common/Icon'
import MarkersWithinPane from './MarkersWithinPane'
import ExportKMZButton from 'components/common/tooltips/ExportKMZButton'
import { selectionTypes } from 'constants.js'
import { withTranslation } from 'react-i18next'
import Toggle from 'components/common/Toggle'
import ProBadge from 'components/common/ProBadge'
import { startProCheckout } from '../../proCheckout'

const RegionAnalysisValid = ({
  uiStore, selectionStore, t
}) => {
  const overrides = selectionStore.data.group ? { data: { group: selectionStore.data.group } } : null
  return (
    <section
      className={classnames({
        'analysis-tall-collapsible': !uiStore.isBarChartActive,
        'analysis-tall-collapsible-active': uiStore.isBarChartActive,
      })} style={{ opacity: uiStore.showIncomeTooltip ? '0.5' : uiStore.showPopulationTooltip ? '0.5' : uiStore.showGenderTooltip ? '0.5' : '' }}
    >
      <Toggle
        icon='three-dots'
        title={t('GLOBAL.HIDE_UNHIDE')}
        enabled={selectionStore.menuItem && !selectionStore.menuItem.visible}
        extraClasses={['three-dots-icon']}
        onClick={(e) => {
          e.stopPropagation()
          selectionStore.showPopupMenu(selectionStore.item, overrides, e)
        }}
      />
      <button type='button' className='close-button' onClick={() => { selectionStore.clear() }}>&times;</button>
      <div className='analysis-header nowrap'>
        <h3>
          <Icon extraClasses={['icon-lg']} id='fa-area-chart' />
          <span className='analysis-title-text'>
            {'group' in selectionStore.data
              ? [
                <span
                  className='analysis-title-part analysis-title-part--group'
                  title={selectionStore.data.group.name}
                  key='group-name'
                >
                  {selectionStore.data.group.name}
                </span>,
                <span className='analysis-title-separator' key='sep'>{' > '}</span>
                ]
              : null}
            <span className='analysis-title-part analysis-title-part--shape' title={selectionStore.item.name}>
              {selectionStore.item.name}
            </span>
          </span>
        </h3>
        {selectionStore.item.analysis.markersMode
          ? (
            <h3>{(selectionStore.type === selectionTypes.TARGET_GROUP)
              ? t('GLOBAL.MARKERS_WITHIN_PLUR')
              : t('GLOBAL.MARKERS_WITHIN_SING')}
            </h3>
            )
          : [
            <button
              className={`export-excel-btn ${uiStore.user && uiStore.user.type === 'starter' ? 'item-controls__disabled' : ''}`}
              key='btn-excel'
              onClick={() => {
                if (uiStore.user && uiStore.user.type === 'starter') {
                  startProCheckout({ uiStore, t })
                  return
                }
                selectionStore.item.analysis.exportExcel(selectionStore.item.name)
              }}
            >
              <Icon id='fa-file-excel-o' />
              <span>{t('GLOBAL.EXCEL_EXPORT')}</span>
              {uiStore.user && uiStore.user.type === 'starter' &&
                <ProBadge className='map-settings__pro text-small'>{t('GLOBAL.PRO')}</ProBadge>}
            </button>,
            <ExportKMZButton key='btn-kmz' disabled={selectionStore.item.fetchingKml} />
            ]}
      </div>
      <div className='analysis-contents'>
        <div className='analysis-column'>
          {selectionStore.item.analysis.markersMode
            ? <MarkersWithinPane />
            : [
              <Summary key='summary' analysis={selectionStore.item.analysis} />,
              <DemographicsBarChart
                key='chart'
                analysis={selectionStore.item.analysis}
                seriesNames={['total', 'female', 'male']}
                seriesLabels={[
                  t('POPULATION.TOTAL'),
                  t('POPULATION.FEMALE'),
                  t('POPULATION.MALE')
                ]}
              />
              ]}
        </div>
      </div>
    </section>
  )
}

export default withTranslation()(inject('uiStore', 'selectionStore')(observer(RegionAnalysisValid)))
